import React from 'react';
export function Footer() {
  return <footer className="bg-navy-950 border-t border-white/10 py-9 sm:py-12" data-id="element-104" data-mp="32wd2qgad7ltj">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105" data-mp="3ggap9r3mg53c">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-6 sm:gap-8 mb-7 sm:mb-9" data-id="element-106" data-mp="32o4b2ak1486j">
          <div className="max-w-md text-center md:text-left" data-id="element-107" data-mp="36oo5359b2vog">
            <div className="font-editorial text-gold/70 text-sm mb-1" data-id="element-108" data-mp="3uf0obca04euc">
              Atlas Clínico
            </div>
            <div className="text-lg sm:text-xl font-heading font-extrabold text-white mb-2 tracking-tight" data-id="element-109" data-mp="3991alritibr">
              ATLAS CLÍNICO™
            </div>
            <p className="text-gray-400 text-[13px] sm:text-sm leading-relaxed" data-id="element-110" data-mp="3le2l2w7e0bct">
              Sistema de consulta y razonamiento clínico para estudiantes y
              profesionales de Kinesiología y Fisioterapia. Material de apoyo:
              no reemplaza la formación universitaria ni el criterio
              profesional.
            </p>
          </div>

          <div className="text-center md:text-right space-y-1.5" data-id="element-111" data-mp="3lalgthavm9v0">
            <a href="mailto:soporte@atlasclinico.com" className="block text-[13px] sm:text-sm text-gray-400 hover:text-gold transition-colors duration-200 ease-out" data-id="element-112" data-mp="3gah29wtj3p7f">
              📧 soporte@atlasclinico.com
            </a>
            <a href="#" className="block text-[13px] sm:text-sm text-gray-400 hover:text-gold transition-colors duration-200 ease-out" data-id="element-113" data-mp="3q7bxa5qlf7gy">
              📲 @atlasclinico
            </a>
            <a href="#" className="block text-[13px] sm:text-sm text-gray-400 hover:text-gold transition-colors duration-200 ease-out" data-id="element-114" data-mp="hstv2knc2m59">
              🌐 www.atlasclinico.com
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-5 flex flex-col md:flex-row justify-between items-center gap-2.5" data-id="element-115" data-mp="qu1g410u9qhe">
          <p className="text-gray-500 text-[11.5px] text-center md:text-left leading-relaxed" data-id="element-116" data-mp="mptptzeqg2h2">
            © Atlas Clínico™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-gold font-editorial italic text-[13px]" data-id="element-117" data-mp="13s9as5etp5ne">
            “Evaluar mejor empieza hoy.”
          </p>
        </div>

        <div className="pt-4" data-id="element-118" data-mp="18m3rczz4t4i9">
          <p className="text-gray-500 text-[11px] leading-relaxed text-center md:text-left" data-id="element-119" data-mp="1cluodlf94gv8">
            Atlas Clínico es una biblioteca digital de consulta. No es software,
            aplicación ni plataforma, y no constituye asesoramiento médico.
          </p>
        </div>
      </div>
    </footer>;
}